import React from 'react';

class Video extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            videoURL: this.props.src,
        }
    }

    componentDidMount() {
        const video = this.refs.video.getDOMNode();

        video.oncanplay = () => {
            video.play();
        };
    }

    render() {
        require('./Video.styl');

        return (
            <video ref="video" src={this.state.videoURL} className="Video" preload="auto" muted="true" autoplay="true" loop="true" playsinline=""></video>
        );
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.js